import { render, staticRenderFns } from "./BaseInputSwitch.vue?vue&type=template&id=6bebda03&scoped=true&"
import script from "./BaseInputSwitch.vue?vue&type=script&lang=js&"
export * from "./BaseInputSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputSwitch.vue?vue&type=style&index=0&id=6bebda03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bebda03",
  null
  
)

export default component.exports